import { handleUnauthorizedError } from "../../services/authUtils";
import FnService from "../../services/FantacyService";
import { saveFnClientCompletedList, saveFnCompletedContestList, saveFnContestList, saveFnCurrentUpcommingList, saveFnPlayersByMatch, saveFnTeamsAll, saveFnUserContestList } from "../slices/fantacySlice";
import store from "../store";

export function getCurrentMatches() {
    return new Promise((resolve, reject) => {
        FnService.getCurrentUpcomingService().then((res) => {
            store.dispatch(saveFnCurrentUpcommingList(res.data))
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}

export function saveUserTeam(teamData) {
    return new Promise((resolve, reject) => {
        FnService.saveUserTeamService(teamData).then((res) => {
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}
export function JoinContest(payload) {
    return new Promise((resolve, reject) => {
        FnService.joinContestService(payload).then((res) => {
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}

export function getTeamsAll(matchId) {
    return new Promise((resolve, reject) => {
        FnService.GetTeamsAllService(matchId).then((res) => {
            store.dispatch(saveFnTeamsAll(res.data))
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}

export function getPlayersByMatch(matchId) {
    return new Promise((resolve, reject) => {
        FnService.GetPlayersByMatchService(matchId).then((res) => {
            store.dispatch(saveFnPlayersByMatch(res.data))
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}

export function getContestList(matchId) {
    return new Promise((resolve, reject) => {
        FnService.GetContestListService(matchId).then((res) => {
            store.dispatch(saveFnContestList(res.data))
            resolve(res)
        }).catch((error) => {
            // handleUnauthorizedError(error);
            // reject(error)
        })
    })
}

export function getUserContestList(matchId) {
    return new Promise((resolve, reject) => {
        FnService.GetUserContestService(matchId).then((res) => {
            store.dispatch(saveFnUserContestList(res.data))
            resolve(res)
        }).catch((error) => {
            // handleUnauthorizedError(error);
            // reject(error)
        })
    })
}

export function getCompletedContestList(matchId) {
    return new Promise((resolve, reject) => {
        FnService.GetCompletedContestListService(matchId).then((res) => {
            store.dispatch(saveFnCompletedContestList(res.data))
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}

export function getClientCompleted() {
    return new Promise((resolve, reject) => {
        FnService.GetClientCompletedService().then((res) => {
            store.dispatch(saveFnClientCompletedList(res.data))
            resolve(res)
        }).catch((error) => {
            handleUnauthorizedError(error);
            reject(error)
        })
    })
}

